import { takeEvery, put, call } from 'redux-saga/effects'
import { actionNames } from './actions'
import { fetchSettings, loadSiteData } from './api'

function* refetchSiteDataWorker(params) {
  try {
    const data = yield call(loadSiteData, params)
    yield put({ type: actionNames.REFETCH_SITE_DATA_SUCCESS, data })
  } catch (err) {
    // TODO handle
  }
}

function* watchRefetchSiteData(params = {}) {
  yield takeEvery(actionNames.REFETCH_SITE_DATA, refetchSiteDataWorker, params)
}

function* fetchSettingsWorker() {
  try {
    const { settings } = yield call(fetchSettings)

    yield put({
      type: actionNames.FETCH_SETTINGS_SUCCESS,
      settings,
    })
  } catch (err) {
    if (err.name === 'permission_denied') {
      window.location.href = `/login?return_url=${encodeURIComponent(
        window.location.pathname
      )}`
    }
  }
}

function* watchFetchSettings() {
  yield takeEvery(actionNames.FETCH_SITE_SETTINGS, fetchSettingsWorker)
}

export { watchRefetchSiteData, watchFetchSettings, fetchSettingsWorker }
